export default __webpack_public_path__ + "static/taxes-rot-720p-56c34a8718d043c8fbb89f66af0b107a.webm";